import type { DefaultBookmarkMethodsInputArgs, GetBookmarksInput } from '../../api/bookmark-api';
import { OneApi } from '../../components/one-api/one-api';
import { createQueryEndpoint } from '../requests/helpers';

export const BookmarkEndpoints = {
  isBookmarked: createQueryEndpoint<DefaultBookmarkMethodsInputArgs, any>('BookmarkAPI.isBookmarked', {
    queryFn: async ({ objectId, classId }) => {
      return await OneApi.bookmarkAPI.isBookmarked({ objectId, classId });
    },
  }),

  bookmark: createQueryEndpoint<DefaultBookmarkMethodsInputArgs, any>('BookmarkAPI.bookmark', {
    queryFn: async (bookmarkInput) => {
      return await OneApi.bookmarkAPI.bookmark(bookmarkInput);
    },
  }),

  unbookmark: createQueryEndpoint<DefaultBookmarkMethodsInputArgs, any>('BookmarkAPI.unbookmark', {
    queryFn: async (unbookMarkInput) => {
      return await OneApi.bookmarkAPI.unbookmark(unbookMarkInput);
    },
  }),

  getBookmarks: createQueryEndpoint<GetBookmarksInput, any>('BookmarkAPI.getBookmarks', {
    queryFn: async (getBookmarksInput) => {
      return await OneApi.bookmarkAPI.getBookmarks(getBookmarksInput);
    },
  }),
};
